import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LegalDocumentationComponent } from '../legal-documentation/legal-documentation.component';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component'; 
import { TermsOfServiceComponent } from './terms-of-service/terms-of-service.component';

// Define the routes
const routes: Routes = [
  {
    path: 'legal-documentation', // Parent route
    component: LegalDocumentationComponent, // Parent component
    children: [
      { path: '', redirectTo: 'terms-of-service', pathMatch: 'full' }, // Default child redirect
      { path: 'privacy-policy', component: PrivacyPolicyComponent },
      { path: 'terms-of-service', component: TermsOfServiceComponent },
    ],
  },
  { path: 'terms-of-service', component: TermsOfServiceComponent }, // Direct path for redirect
];

@NgModule({
  imports: [RouterModule.forChild(routes)], 
  exports: [RouterModule], 
})
export class LegalDocumentationRoutingModule {}
